<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogAboutAge"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogAboutAge-title">「年齢」について</h1>
    </template>
    <v-card>
      <v-card-text class="dialogAboutAge-content">
        <p>各保険商品の「年齢(被保険者ごと)」の考え方は次のとおりです。</p>
        <ul>
          <li>
            <h2>NEW (希) 保険</h2>
            <p>
              NEW(希)保険の「年齢」は保険年齢です。保険年齢は2026年1月1日（更新日）時点の満年齢で計算し、1年未満の端数は6カ月以下を切捨て、
              6カ月超を切上げます。
            </p>
          </li>
          <li>
            <h2>団体医療保険制度（被保険者）</h2>
            <ol>
              <li>新規ご加入の方・・・加入日(注)時点の満年齢</li>
              <li>保障追加、加入内容変更の方・・・保険年度(毎年1月1日～翌年1月1日)ごとの最初の加入日時点の満年齢
              </li>
              <li>(注)毎月1日付で中途加入できます。</li>
            </ol>
          </li>
          <!-- <li>
            <h2>Days1</h2>
            <p>被保険者の契約日における満年齢(1年未満は切り捨て)です。</p>
          </li>
          <li>
            <h2>(医)終身プラス</h2>
            <p>被保険者の契約日における満年齢(1年未満は切り捨て)です。</p>
          </li> -->
        </ul>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogAboutAge',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogAboutAge {
  max-width: 720px;

  &-content {
    &.v-card__text {
      padding: 0 30px 20px;
    }
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
  p {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: normal;
    text-align: left;
    color: #333;
  }
  ul {
    padding-left: 15px;
    li {
      &::before {
        content: '\2022'; /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: rgba(51, 51, 51, 0.5); /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        font-size: 20px;
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 15px; /* Also needed for space (tweak if needed) */
        margin-left: -15px; /* Also needed for space (tweak if needed) */
      }
      h2 {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #333;
        background: unset;
        padding: 0;
      }
    }
  }
  ol {
    li {
      list-style-type: decimal;
      &::before {
        content: unset;
      }
    }
  }
}
</style>
